import React from 'react';

import style from './index.module.scss';

import clsx from 'clsx';
import { Box, BoxProps } from '@mui/material';
import { Stack } from 'components/stack';

interface Classes {
  root: string;
  label: string;
  value: string;
}

interface Props {
  className?: string;
  classes?: Partial<Classes>;
  label: React.ReactNode;
  LabelProps?: Partial<BoxProps>;
}

export const RowField: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  label,
  LabelProps,
  classes,
  children,
}) => {
  return (
    <Stack
      className={clsx(style.root, classes?.root, className)}
      sx={{
        alignItems: '',
      }}
    >
      <Box
        component={'span'}
        {...LabelProps}
        className={clsx(style.label, classes?.label, LabelProps?.className)}
        sx={[
          {
            minWidth: '30%',
            maxWidth: '30%',
          },
          ...(Array.isArray(LabelProps?.sx) ? LabelProps.sx : [LabelProps?.sx]),
        ]}
      >
        {label}
      </Box>
      <div className={clsx(style.value, classes?.value)}>{children}</div>
    </Stack>
  );
};
